module.exports = __webpack_public_path__ + "img/marker.c5cafe03.png";